'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  margin: 10px 0px;\n  position: relative;\n  visibility: ', ';\n  opacity: ', ';\n  transform: ', ';\n  ', ';\n'], ['\n  width: 100%;\n  margin: 10px 0px;\n  position: relative;\n  visibility: ', ';\n  opacity: ', ';\n  transform: ', ';\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Alert = require('../../Alert/Alert');

var _Alert2 = _interopRequireDefault(_Alert);

var _alert = require('../../../libs/alert');

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Libs


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var visible = _ref.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 1 : 0;
}, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 'none' : 'translateY(calc(100% + 10px))';
}, (0, _polished.transitions)('visibility .3s ease-in-out, opacity .3s ease-in-out, transform .3s ease-in-out'));

var AlertSystemNode = function (_Component) {
  _inherits(AlertSystemNode, _Component);

  function AlertSystemNode() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, AlertSystemNode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = AlertSystemNode.__proto__ || Object.getPrototypeOf(AlertSystemNode)).call.apply(_ref4, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlertSystemNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.setState({
          visible: true
        });
      }, 20);
      this.startTiming();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopTiming();
    }
  }, {
    key: 'render',
    value: function render() {
      var visible = this.state.visible;
      var _props = this.props,
          type = _props.type,
          content = _props.content;
      return _react2.default.createElement(Container, {
        visible: visible,
        onMouseEnter: this.hoverIn,
        onMouseLeave: this.hoverOut
      }, _react2.default.createElement(_Alert2.default, {
        type: type,
        undo: this.undo()
      }, content));
    }
  }]);

  return AlertSystemNode;
}(_react.Component);

AlertSystemNode.propTypes = {
  duration: _propTypes2.default.number.isRequired,
  pauseOnHover: _propTypes2.default.bool,
  id: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  content: _propTypes2.default.node.isRequired,
  undo: _propTypes2.default.func
};
AlertSystemNode.defaultProps = {
  pauseOnHover: false
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    visible: false
  };
  this.timer = null;

  this.startTiming = function () {
    var duration = _this3.props.duration;

    _this3.stopTiming();

    _this3.timer = setTimeout(_this3.close, duration);
  };

  this.close = function () {
    _this3.stopTiming();

    _this3.setState({
      visible: false
    });

    setTimeout(function () {
      return _alert2.default.remove(_this3.props.id);
    }, 310);
  };

  this.stopTiming = function () {
    if (!_this3.timer) return;
    clearTimeout(_this3.timer);
    _this3.timer = null;
  };

  this.hoverIn = function () {
    if (!_this3.props.pauseOnHover) return;

    _this3.stopTiming();
  };

  this.hoverOut = function () {
    if (!_this3.props.pauseOnHover) return;

    _this3.startTiming();
  };

  this.undo = function () {
    var undo = _this3.props.undo;
    if (!undo) return null;
    return function () {
      _this3.close();

      undo.apply(undefined, arguments);
    };
  };
};

exports.default = AlertSystemNode;